import { ADDED_MASHING_ITEMS_TO_MAP, UPDATED_MASHINGS_ID } from '#models/general/mashings/constants';
import { STATUS } from '#constants/status';
import { STEPS_STATUS_IDS } from '#models/general/steps/constants';

export const mapAddedMashings = response =>
  response.data.map(mashing =>
    ADDED_MASHING_ITEMS_TO_MAP.reduce(
      (prevValues, actValue, currentIndex) => ({ ...prevValues, [actValue]: mashing?.args[currentIndex] }),
      {}
    )
  );

export const mapUpdatedMashings = response => response.data.map(({ args }) => args?.[UPDATED_MASHINGS_ID]);

export const mapAddMashing = ({
  mashingData = {},
  mashingId = '',
  periodId = '',
  milledDate = '',
  mashDate = '',
  note = ''
}) => [JSON.stringify(mashingData), mashingId, periodId, milledDate, mashDate, note];

export const mapUpdateMashing = ({ mashingData = {}, mashingId = '' }) => [
  JSON.stringify(mashingData),
  mashingId
];

export const mapCreateMash = params => ({
  ...params?.mashingData,
  [STEPS_STATUS_IDS.MASH]: STATUS.IN_PROGRESS
});

export const mapUpdateMashStep = params => ({
  ...params?.mashingData,
  [STEPS_STATUS_IDS.MASH]: STATUS.COMPLETED,
  [STEPS_STATUS_IDS.WASH]: STATUS.IN_PROGRESS
});
